<template>
  <OfflineLayout>
    <div>
      <Message
        v-if="success"
        severity="success"
        :closable="false"
      >
        {{ $t(success) }}
      </Message>

      <Message
        v-if="error"
        severity="error"
        :closable="false"
      >
        {{ $t(error) }}
      </Message>

      <router-link to="login">
        {{ $t('activationPage.backtohome') }}
      </router-link>
    </div>
  </OfflineLayout>
</template>

<script>
import OfflineLayout from "@/layouts/OfflineLayout";
import Message from "primevue/message";

export default {
  components: {OfflineLayout, Message},
  data() {
    return {
      success: '',
      error: ''
    }
  },
  async mounted() {
    const activationCode = this.$route.query.activationCode;

    if (!activationCode) {
      this.error = 'validations.activation.activationCode.invalid'
      return
    }

    try {
      const result = await this.$userService.activateUser(activationCode);
      if (result) {
        this.success = 'activationPage.success'
      } else {
        this.error = 'activationPage.failed'
      }
    } catch (err) {
      this.error = err.response.data
    }
  }
}
</script>
